import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

var _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context16; _forEachInstanceProperty(_context16 = ownKeys(source, true)).call(_context16, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context17; _forEachInstanceProperty(_context17 = ownKeys(source)).call(_context17, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import isEqual from 'react-fast-compare';
import withContext from './containers/with-context';
import { noop, isPromise, isFunction, isObject, isNullOrUndefined, uuid, reduceError } from './utils';
import { get, set } from 'lodash';

var Field = withContext(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  _inherits(Field, _Component);

  function Field(props) {
    var _context, _context2, _context3, _context4, _context5, _context6, _context7;

    var _this;

    _classCallCheck(this, Field);

    var name = props.name,
        initialValue = props.initialValue,
        shouldUnregister = props.shouldUnregister,
        _props$reactForms = props.reactForms,
        currentValues = _valuesInstanceProperty(_props$reactForms),
        currentTouched = _props$reactForms.touched,
        currentErrors = _props$reactForms.errors,
        initialValues = _props$reactForms.initialValues,
        touchOnMount = _props$reactForms.touchOnMount,
        formShouldUnregister = _props$reactForms.shouldUnregister,
        registerField = _props$reactForms.registerField;

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Field).call(this, props));
    var formInitialValue = get(initialValues, name);
    var currentFormValue = get(currentValues, name);
    var currentFormTouched = get(currentTouched, name);
    var currentFormError = get(currentErrors, name);
    var value = !isNullOrUndefined(currentFormValue) ? currentFormValue : !isNullOrUndefined(initialValue) ? initialValue : !isNullOrUndefined(formInitialValue) ? formInitialValue : '';
    var touched = !isNullOrUndefined(currentFormTouched) ? currentFormTouched : !!touchOnMount;
    var error = !isNullOrUndefined(currentFormError) ? currentFormError : null;
    _this.state = {
      value: value,
      touched: touched,
      error: error,
      focused: false,
      initialValue: value,
      isValidating: false
    };
    _this.id = props.id || uuid();
    _this.mounted = false;
    _this.shouldUnregister = !isNullOrUndefined(shouldUnregister) ? shouldUnregister : formShouldUnregister;
    registerField(name, _objectSpread({
      id: _this.id,
      initialValue: value,
      initialTouched: touched,
      initialError: error
    }, _this.getRegistrations()));
    _this.setFieldState = _bindInstanceProperty(_context = _this.setFieldState).call(_context, _assertThisInitialized(_this));
    _this.getRegistrations = _bindInstanceProperty(_context2 = _this.getRegistrations).call(_context2, _assertThisInitialized(_this));
    _this.handleValidate = _bindInstanceProperty(_context3 = _this.handleValidate).call(_context3, _assertThisInitialized(_this));
    _this.handleFocus = _bindInstanceProperty(_context4 = _this.handleFocus).call(_context4, _assertThisInitialized(_this));
    _this.handleChange = _bindInstanceProperty(_context5 = _this.handleChange).call(_context5, _assertThisInitialized(_this));
    _this.handleBlur = _bindInstanceProperty(_context6 = _this.handleBlur).call(_context6, _assertThisInitialized(_this));
    _this.getFieldProps = _bindInstanceProperty(_context7 = _this.getFieldProps).call(_context7, _assertThisInitialized(_this));
    return _this;
  }

  _createClass(Field, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var _this$props = this.props,
          name = _this$props.name,
          children = _this$props.children,
          render = _this$props.render,
          InputComponent = _this$props.Component,
          initialValue = _this$props.initialValue,
          reactForms = _this$props.reactForms,
          sendImmediate = _this$props.sendImmediate,
          shouldUnregister = _this$props.shouldUnregister,
          validate = _this$props.validate,
          onFocus = _this$props.onFocus,
          onChange = _this$props.onChange,
          onBlur = _this$props.onBlur,
          rest = _objectWithoutProperties(_this$props, ["name", "children", "render", "Component", "initialValue", "reactForms", "sendImmediate", "shouldUnregister", "validate", "onFocus", "onChange", "onBlur"]);

      var newName = nextProps.name,
          newChildren = nextProps.children,
          newRender = nextProps.render,
          NewInputComponent = nextProps.Component,
          newInitialValue = nextProps.initialValue,
          newReactForms = nextProps.reactForms,
          newSendImmediate = nextProps.sendImmediate,
          newShouldUnregister = nextProps.shouldUnregister,
          newValidate = nextProps.validate,
          newOnFocus = nextProps.onFocus,
          newOnChange = nextProps.onChange,
          newOnBlur = nextProps.onBlur,
          newRest = _objectWithoutProperties(nextProps, ["name", "children", "render", "Component", "initialValue", "reactForms", "sendImmediate", "shouldUnregister", "validate", "onFocus", "onChange", "onBlur"]);

      if (this.state !== nextState) {
        return true;
      }

      if (name !== newName || children !== newChildren || render !== newRender || InputComponent !== NewInputComponent) {
        return true;
      }

      if (!isEqual(rest, newRest)) {
        return true;
      }

      return false;
    }
  }, {
    key: "getRegistrations",
    value: function getRegistrations() {
      var _this2 = this;

      var _this$props2 = this.props,
          validate = _this$props2.validate,
          _this$props2$reactFor = _this$props2.reactForms,
          validateOnMount = _this$props2$reactFor.validateOnMount,
          validateOnChange = _this$props2$reactFor.validateOnChange,
          validateOnBlur = _this$props2$reactFor.validateOnBlur,
          touchOnMount = _this$props2$reactFor.touchOnMount;
      return {
        validate: validate,
        setValue: function setValue(value) {
          var shouldValidate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : validateOnChange;
          return new _Promise(
          /*#__PURE__*/
          function () {
            var _ref = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee(resolve) {
              var promises, error;
              return _regeneratorRuntime.wrap(function _callee$(_context8) {
                while (1) {
                  switch (_context8.prev = _context8.next) {
                    case 0:
                      promises = [_this2.setFieldState(function (prevState) {
                        return _objectSpread({}, prevState, {
                          value: value
                        });
                      }), _this2.sendValue(value)];

                      if (!shouldValidate) {
                        _context8.next = 14;
                        break;
                      }

                      error = _this2.handleValidate(value);

                      if (!isPromise(error)) {
                        _context8.next = 13;
                        break;
                      }

                      _context8.t0 = promises;
                      _context8.t1 = _this2;
                      _context8.next = 8;
                      return error;

                    case 8:
                      _context8.t2 = _context8.sent;
                      _context8.t3 = _context8.t1.sendError.call(_context8.t1, _context8.t2);

                      _context8.t0.push.call(_context8.t0, _context8.t3);

                      _context8.next = 14;
                      break;

                    case 13:
                      promises.push(_this2.sendError(error));

                    case 14:
                      _context8.next = 16;
                      return _Promise.all(promises);

                    case 16:
                      resolve(value);

                    case 17:
                    case "end":
                      return _context8.stop();
                  }
                }
              }, _callee);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }());
        },
        setError: function setError(error) {
          var shouldTouch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
          return new _Promise(
          /*#__PURE__*/
          function () {
            var _ref2 = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee2(resolve) {
              var promises;
              return _regeneratorRuntime.wrap(function _callee2$(_context9) {
                while (1) {
                  switch (_context9.prev = _context9.next) {
                    case 0:
                      promises = [_this2.setFieldState(function (prevState) {
                        return _objectSpread({}, prevState, {
                          error: error,
                          touched: !!shouldTouch
                        });
                      })];

                      if (shouldTouch) {
                        promises.push(_this2.sendTouched(shouldTouch));
                      }

                      promises.push(_this2.sendError(error));
                      _context9.next = 5;
                      return _Promise.all(promises);

                    case 5:
                      resolve(error);

                    case 6:
                    case "end":
                      return _context9.stop();
                  }
                }
              }, _callee2);
            }));

            return function (_x2) {
              return _ref2.apply(this, arguments);
            };
          }());
        },
        setTouched: function setTouched(touched) {
          var shouldValidate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : validateOnBlur;
          return new _Promise(
          /*#__PURE__*/
          function () {
            var _ref3 = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee3(resolve) {
              var value, promises, error;
              return _regeneratorRuntime.wrap(function _callee3$(_context10) {
                while (1) {
                  switch (_context10.prev = _context10.next) {
                    case 0:
                      value = _this2.state.value;
                      promises = [_this2.setFieldState(function (prevState) {
                        return _objectSpread({}, prevState, {
                          touched: touched
                        });
                      }), _this2.sendTouched(touched)];

                      if (!shouldValidate) {
                        _context10.next = 15;
                        break;
                      }

                      error = _this2.handleValidate(value);

                      if (!isPromise(error)) {
                        _context10.next = 14;
                        break;
                      }

                      _context10.t0 = promises;
                      _context10.t1 = _this2;
                      _context10.next = 9;
                      return error;

                    case 9:
                      _context10.t2 = _context10.sent;
                      _context10.t3 = _context10.t1.sendError.call(_context10.t1, _context10.t2);

                      _context10.t0.push.call(_context10.t0, _context10.t3);

                      _context10.next = 15;
                      break;

                    case 14:
                      promises.push(_this2.sendError(error));

                    case 15:
                      _context10.next = 17;
                      return _Promise.all(promises);

                    case 17:
                      resolve(touched);

                    case 18:
                    case "end":
                      return _context10.stop();
                  }
                }
              }, _callee3);
            }));

            return function (_x3) {
              return _ref3.apply(this, arguments);
            };
          }());
        },
        reset: function reset(val) {
          var shouldValidate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : validateOnMount;
          return new _Promise(
          /*#__PURE__*/
          function () {
            var _ref4 = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee4(resolve) {
              var initialValue, value, touched, maybePromisedError, promises, error;
              return _regeneratorRuntime.wrap(function _callee4$(_context11) {
                while (1) {
                  switch (_context11.prev = _context11.next) {
                    case 0:
                      initialValue = _this2.state.initialValue;
                      value = !isNullOrUndefined(val) ? val : initialValue;
                      touched = shouldValidate && !!touchOnMount;
                      maybePromisedError = shouldValidate && _this2.handleValidate(value) || null;
                      promises = [_this2.setFieldState(function (prevState) {
                        return _objectSpread({}, prevState, {
                          value: value,
                          touched: touched,
                          initialValue: value
                        });
                      }), _this2.sendInitialValue(value), _this2.sendValue(value), _this2.sendTouched(touched)];

                      if (!isPromise(maybePromisedError)) {
                        _context11.next = 15;
                        break;
                      }

                      _context11.next = 8;
                      return maybePromisedError;

                    case 8:
                      error = _context11.sent;
                      promises.push(_this2.sendError(error));
                      _context11.next = 12;
                      return _Promise.all(promises);

                    case 12:
                      resolve({
                        value: value,
                        touched: touched,
                        error: error
                      });
                      _context11.next = 19;
                      break;

                    case 15:
                      promises.push(_this2.sendError(maybePromisedError));
                      _context11.next = 18;
                      return _Promise.all(promises);

                    case 18:
                      resolve({
                        value: value,
                        touched: touched,
                        error: maybePromisedError
                      });

                    case 19:
                    case "end":
                      return _context11.stop();
                  }
                }
              }, _callee4);
            }));

            return function (_x4) {
              return _ref4.apply(this, arguments);
            };
          }());
        }
      };
    }
  }, {
    key: "setFieldState",
    value: function setFieldState(state) {
      var _this3 = this;

      return new _Promise(function (resolve) {
        if (_this3.mounted) {
          _this3.setState(state, resolve);
        } else {
          resolve();
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var value, validateOnMount, maybePromisedError;
        return _regeneratorRuntime.wrap(function _callee5$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                value = this.state.value;
                validateOnMount = this.props.reactForms.validateOnMount;
                this.mounted = true;

                if (!validateOnMount) {
                  _context12.next = 14;
                  break;
                }

                maybePromisedError = this.handleValidate(value);

                if (!isPromise(maybePromisedError)) {
                  _context12.next = 13;
                  break;
                }

                _context12.t0 = this;
                _context12.next = 9;
                return maybePromisedError;

              case 9:
                _context12.t1 = _context12.sent;

                _context12.t0.sendError.call(_context12.t0, _context12.t1);

                _context12.next = 14;
                break;

              case 13:
                this.sendError(maybePromisedError);

              case 14:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee5, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$state = this.state,
          value = _this$state.value,
          touched = _this$state.touched,
          error = _this$state.error;
      var _this$props3 = this.props,
          name = _this$props3.name,
          shouldUnregister = _this$props3.shouldUnregister,
          _this$props3$reactFor = _this$props3.reactForms,
          formShouldUnregister = _this$props3$reactFor.shouldUnregister,
          registerField = _this$props3$reactFor.registerField,
          unregisterField = _this$props3$reactFor.unregisterField;
      var prevName = prevProps.name,
          prevShouldUnregister = prevProps.shouldUnregister;

      if (shouldUnregister !== prevShouldUnregister) {
        this.shouldUnregister = !isNullOrUndefined(shouldUnregister) ? shouldUnregister : formShouldUnregister;
      }

      if (name !== prevName) {
        if (this.shouldUnregister) {
          unregisterField(this.id);
        }

        registerField(name, _objectSpread({
          id: this.id,
          initialValue: value,
          initialTouched: touched,
          initialError: error
        }, this.getRegistrations()));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var unregisterField = this.props.reactForms.unregisterField;
      this.mounted = false;

      if (this.shouldUnregister) {
        unregisterField(this.id);
      }
    }
  }, {
    key: "sendInitialValue",
    value: function sendInitialValue(value) {
      var _this$props4 = this.props,
          name = _this$props4.name,
          setFormState = _this$props4.reactForms.setFormState;
      return setFormState(function (prevState) {
        return _objectSpread({}, prevState, {
          fields: _objectSpread({}, prevState.fields, _defineProperty({}, name, set(_objectSpread({}, prevState.fields[name]), 'initialValue', value)))
        });
      });
    }
  }, {
    key: "sendValue",
    value: function sendValue(value) {
      var _this$props5 = this.props,
          name = _this$props5.name,
          setFormState = _this$props5.reactForms.setFormState;
      return setFormState(function (prevState) {
        return _objectSpread({}, prevState, {
          fields: _objectSpread({}, prevState.fields, _defineProperty({}, name, set(_objectSpread({}, prevState.fields[name]), 'value', value)))
        });
      });
    }
  }, {
    key: "sendTouched",
    value: function sendTouched(touched) {
      var _this$props6 = this.props,
          name = _this$props6.name,
          setFormState = _this$props6.reactForms.setFormState;
      return setFormState(function (prevState) {
        return _objectSpread({}, prevState, {
          fields: _objectSpread({}, prevState.fields, _defineProperty({}, name, set(_objectSpread({}, prevState.fields[name]), 'touched', touched)))
        });
      });
    }
  }, {
    key: "sendError",
    value: function sendError(error) {
      var _this$props7 = this.props,
          name = _this$props7.name,
          setFormState = _this$props7.reactForms.setFormState;
      return setFormState(function (prevState) {
        return _objectSpread({}, prevState, {
          fields: _objectSpread({}, prevState.fields, _defineProperty({}, name, set(_objectSpread({}, prevState.fields[name]), 'error', error)))
        });
      });
    }
  }, {
    key: "handleValidate",
    value: function handleValidate(value) {
      var _this4 = this;

      var _this$props8 = this.props,
          name = _this$props8.name,
          validate = _this$props8.validate,
          _this$props8$reactFor = _this$props8.reactForms,
          formValues = _valuesInstanceProperty(_this$props8$reactFor),
          validateForm = _this$props8$reactFor.validateForm,
          getFormHelpers = _this$props8$reactFor.getFormHelpers; // Run both field level and form level validations
      // to make sure that all possible errors are accounted for
      // Always use the first error found


      var asyncValidators = [];
      var syncErrors = [];

      if (isFunction(validate)) {
        var maybePromisedError = validate(value, getFormHelpers(true)) || null;

        if (isPromise(maybePromisedError)) {
          asyncValidators.push(maybePromisedError);
        } else {
          syncErrors.push(maybePromisedError);
        }
      }

      if (isFunction(validateForm)) {
        var values = set(_objectSpread({}, formValues), name, value);
        var maybePromisedErrors = validateForm(values, getFormHelpers(true));

        if (isPromise(maybePromisedErrors)) {
          asyncValidators.push(maybePromisedErrors);
        } else {
          var error = get(maybePromisedErrors, name, null);
          syncErrors.push(error);
        }
      }

      var reducedSyncError = reduceError(syncErrors, name); // Either return a promise that resolves to the error
      // or just the error so we can make as few updates as possible

      if (reducedSyncError) {
        this.setFieldState(function (prevState) {
          return _objectSpread({}, prevState, {
            error: reducedSyncError
          });
        });
        return reducedSyncError;
      } else if (asyncValidators.length !== 0) {
        return new _Promise(
        /*#__PURE__*/
        function () {
          var _ref5 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee6(resolve) {
            var error;
            return _regeneratorRuntime.wrap(function _callee6$(_context13) {
              while (1) {
                switch (_context13.prev = _context13.next) {
                  case 0:
                    _context13.next = 2;
                    return _this4.setFieldState(function (prevState) {
                      return _objectSpread({}, prevState, {
                        isValidating: true
                      });
                    });

                  case 2:
                    _context13.t0 = reduceError;
                    _context13.next = 5;
                    return _Promise.all(asyncValidators);

                  case 5:
                    _context13.t1 = _context13.sent;
                    _context13.t2 = name;
                    error = (0, _context13.t0)(_context13.t1, _context13.t2);
                    _context13.next = 10;
                    return _this4.setFieldState(function (prevState) {
                      return _objectSpread({}, prevState, {
                        error: error,
                        isValidating: false
                      });
                    });

                  case 10:
                    resolve(error);

                  case 11:
                  case "end":
                    return _context13.stop();
                }
              }
            }, _callee6);
          }));

          return function (_x5) {
            return _ref5.apply(this, arguments);
          };
        }());
      } // If no validation then set error to null


      this.setFieldState(function (prevState) {
        return _objectSpread({}, prevState, {
          error: null
        });
      });
      return null;
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      var onFocus = this.props.onFocus;

      if (isObject(e) && e.persist) {
        e.persist();
      }

      onFocus(e);
      this.setFieldState(function (prevState) {
        return _objectSpread({}, prevState, {
          focused: true
        });
      });
    }
  }, {
    key: "handleChange",
    value: function () {
      var _handleChange = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(e) {
        var _this$state2, focused, touched, _this$props9, onChange, sendImmediate, _this$props9$reactFor, validateOnChange, touchOnChange, type, value, maybePromisedError;

        return _regeneratorRuntime.wrap(function _callee7$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _this$state2 = this.state, focused = _this$state2.focused, touched = _this$state2.touched;
                _this$props9 = this.props, onChange = _this$props9.onChange, sendImmediate = _this$props9.sendImmediate, _this$props9$reactFor = _this$props9.reactForms, validateOnChange = _this$props9$reactFor.validateOnChange, touchOnChange = _this$props9$reactFor.touchOnChange;

                if (isObject(e) && e.persist) {
                  e.persist();
                }

                type = e.target.type;
                value = type === 'checkbox' ? e.target.checked : type === 'file' ? e.target.files : e.target.value;
                onChange(e);
                this.setFieldState(function (prevState) {
                  return _objectSpread({}, prevState, {
                    value: value,
                    touched: touched || !!touchOnChange
                  });
                });

                if (sendImmediate || !focused) {
                  this.sendValue(value);
                  this.sendTouched(touched || !!touchOnChange);
                }

                if (!validateOnChange) {
                  _context14.next = 20;
                  break;
                }

                maybePromisedError = this.handleValidate(value);

                if (!isPromise(maybePromisedError)) {
                  _context14.next = 19;
                  break;
                }

                if (!(sendImmediate || !focused)) {
                  _context14.next = 17;
                  break;
                }

                _context14.t0 = this;
                _context14.next = 15;
                return maybePromisedError;

              case 15:
                _context14.t1 = _context14.sent;

                _context14.t0.sendError.call(_context14.t0, _context14.t1);

              case 17:
                _context14.next = 20;
                break;

              case 19:
                if (sendImmediate || !focused) {
                  this.sendError(maybePromisedError);
                }

              case 20:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee7, this);
      }));

      function handleChange(_x6) {
        return _handleChange.apply(this, arguments);
      }

      return handleChange;
    }()
  }, {
    key: "handleBlur",
    value: function () {
      var _handleBlur = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(e) {
        var _this$state3, value, touched, error, _this$props10, onBlur, _this$props10$reactFo, validateOnBlur, touchOnBlur, maybePromisedError;

        return _regeneratorRuntime.wrap(function _callee8$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _this$state3 = this.state, value = _this$state3.value, touched = _this$state3.touched, error = _this$state3.error;
                _this$props10 = this.props, onBlur = _this$props10.onBlur, _this$props10$reactFo = _this$props10.reactForms, validateOnBlur = _this$props10$reactFo.validateOnBlur, touchOnBlur = _this$props10$reactFo.touchOnBlur;

                if (isObject(e) && e.persist) {
                  e.persist();
                }

                onBlur(e);
                this.setFieldState(function (prevState) {
                  return _objectSpread({}, prevState, {
                    touched: touched || !!touchOnBlur,
                    focused: false
                  });
                });
                this.sendValue(value);
                this.sendTouched(touched || !!touchOnBlur);

                if (!validateOnBlur) {
                  _context15.next = 20;
                  break;
                }

                maybePromisedError = this.handleValidate(value);

                if (!isPromise(maybePromisedError)) {
                  _context15.next = 17;
                  break;
                }

                _context15.t0 = this;
                _context15.next = 13;
                return maybePromisedError;

              case 13:
                _context15.t1 = _context15.sent;

                _context15.t0.sendError.call(_context15.t0, _context15.t1);

                _context15.next = 18;
                break;

              case 17:
                this.sendError(maybePromisedError);

              case 18:
                _context15.next = 21;
                break;

              case 20:
                this.sendError(error);

              case 21:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee8, this);
      }));

      function handleBlur(_x7) {
        return _handleBlur.apply(this, arguments);
      }

      return handleBlur;
    }()
  }, {
    key: "getFieldProps",
    value: function getFieldProps() {
      var _this$state4 = this.state,
          value = _this$state4.value,
          touched = _this$state4.touched,
          error = _this$state4.error,
          focused = _this$state4.focused,
          initialValue = _this$state4.initialValue,
          isValidating = _this$state4.isValidating;
      var name = this.props.name;
      return {
        id: this.id,
        name: name,
        value: value,
        meta: {
          error: error,
          touched: touched,
          focused: focused,
          initialValue: initialValue,
          isValidating: isValidating
        },
        onFocus: this.handleFocus,
        onChange: this.handleChange,
        onBlur: this.handleBlur
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getFieldProps = this.getFieldProps(),
          meta = _this$getFieldProps.meta,
          restField = _objectWithoutProperties(_this$getFieldProps, ["meta"]);

      var _this$props11 = this.props,
          initialValue = _this$props11.initialValue,
          reactForms = _this$props11.reactForms,
          sendImmediate = _this$props11.sendImmediate,
          shouldUnregister = _this$props11.shouldUnregister,
          InputComponent = _this$props11.Component,
          children = _this$props11.children,
          render = _this$props11.render,
          validate = _this$props11.validate,
          onFocus = _this$props11.onFocus,
          onChange = _this$props11.onChange,
          onBlur = _this$props11.onBlur,
          restProps = _objectWithoutProperties(_this$props11, ["initialValue", "reactForms", "sendImmediate", "shouldUnregister", "Component", "children", "render", "validate", "onFocus", "onChange", "onBlur"]);

      var props = _objectSpread({}, restProps, {
        field: _objectSpread({}, restField),
        meta: meta
      });

      return isFunction(children) ? children(props) : isFunction(render) ? render(props) : isFunction(InputComponent) ? React.createElement(InputComponent, props) : InputComponent ? React.createElement(InputComponent, restField) : null;
    }
  }]);

  return Field;
}(Component), _defineProperty(_class2, "defaultProps", {
  sendImmediate: false,
  Component: 'input',
  onFocus: noop,
  onChange: noop,
  onBlur: noop
}), _temp)) || _class;

export default Field;